export const CANCEL_ORDER_REQUEST = 'CANCEL_ORDER_REQUEST';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAILURE = 'CANCEL_ORDER_FAILURE';
export const cancelOrderRequest = (payload) => ({
    type: CANCEL_ORDER_REQUEST,
    payload,
});
export const cancelOrderSuccess = (payload) => ({
    type: CANCEL_ORDER_SUCCESS,
    payload,
});
export const cancelOrderFailure = (payload) => ({
    type: CANCEL_ORDER_FAILURE,
    payload,
});
